var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-detail"},[(_vm.$slots.default)?_c('div',{staticClass:"c-detail-content"},[_vm._t("default")],2):_vm._e(),_vm._t("custom"),(_vm.$slots.button)?_c('div',{staticClass:"flex-center c-detail-button"},[_vm._t("button")],2):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }